import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tables } from "@/integrations/supabase/types";
import { format } from "date-fns";

type Lead = Tables<"leads">;

export const AdditionalInformation = ({ lead }: { lead: Lead }) => (
  <Card className="mb-6">
    <CardHeader>
      <CardTitle>Additional Information</CardTitle>
    </CardHeader>
    <CardContent className="space-y-2">
      <div>
        <div className="font-medium">Primary Concern</div>
        <div>{lead.concern || "Not specified"}</div>
      </div>
      <div>
        <div className="font-medium">Details</div>
        <div>{lead.details || "Not provided"}</div>
      </div>
      <div>
        <div className="font-medium">Source</div>
        <div className="capitalize">{lead.source.replace(/_/g, " ")}</div>
      </div>
      <div>
        <div className="font-medium">Created</div>
        <div>{format(new Date(lead.created_at), "MMMM d, yyyy")}</div>
      </div>
    </CardContent>
  </Card>
);